import { render, staticRenderFns } from "./text-section.vue?vue&type=template&id=c3d8827a&"
import script from "./text-section.vue?vue&type=script&lang=js&"
export * from "./text-section.vue?vue&type=script&lang=js&"
import style0 from "./text-section.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports